import { useBaseParam } from './useBaseParam';
import { getBaseKeypad } from '../../infra/api/getBaseKeypad';
import { useEffect, useState } from 'react';

const useKeypad = () => {
  const fetchEncryptedPad = useBaseParam(getBaseKeypad, {});
  const [keypad, setKeypad] = useState();

  const refetchEncryptedPad = async () => {
    const result = await fetchEncryptedPad();
    setKeypad(result?.data?.result?.list ?? []);
  };

  useEffect(() => {
    refetchEncryptedPad();
    const encryptedPadInterval = setInterval(() => {
      refetchEncryptedPad();
    }, 1000 * 60 * 4);
    return () => {
      clearInterval(encryptedPadInterval);
    };
  }, []);

  return {
    keypad: keypad,
  };
};

export default useKeypad;
